import { triggerInputChange } from "./HTMLUtils";
function isValidNumberInput(value) {
    var _a, _b;
    // the browser allows some invalid input but not others
    // it allows up to two '-' at any place before any 'e' or one directly following 'e'
    // it allows one '.' at any place before e
    const valueParts = value.split("e", 2);
    return !(/[^\d.\-e]/.test(value) ||
        Number((_a = value.match(/-/g)) === null || _a === void 0 ? void 0 : _a.length) > 2 ||
        Number((_b = value.match(/\./g)) === null || _b === void 0 ? void 0 : _b.length) > 1 ||
        (valueParts[1] && !/^-?\d*$/.test(valueParts[1])));
}
function isElementType(element, tag, props) {
    if (element.namespaceURI && element.namespaceURI !== "http://www.w3.org/1999/xhtml") {
        return false;
    }
    tag = Array.isArray(tag) ? tag : [tag];
    // tagName is uppercase in HTMLDocument and lowercase in XMLDocument
    if (!tag.includes(element.tagName.toLowerCase())) {
        return false;
    }
    if (props) {
        return Object.entries(props).every(([k, v]) => element[k] === v);
    }
    return true;
}
export class HTMLUserEvents {
    static input(element, key, selectionStart, selectionEnd) {
        var _a, _b;
        const anchorOffset = selectionStart != undefined ? selectionStart : (_a = element.selectionStart) !== null && _a !== void 0 ? _a : 0;
        const focusOffset = selectionEnd != undefined ? selectionEnd : (_b = element.selectionEnd) !== null && _b !== void 0 ? _b : 0;
        const inputRange = {
            anchorOffset,
            focusOffset,
            startOffset: Math.min(anchorOffset, focusOffset),
            endOffset: Math.max(anchorOffset, focusOffset)
        };
        const oldValue = element.value;
        let inputType = "insertText";
        if (key === "Delete") {
            key = "";
            inputType = "deleteContentForward";
        }
        else if (key === "Backspace") {
            key = "";
            inputType = "deleteContentBackward";
        }
        else if (key === "Enter") {
            key = "";
        }
        else if (key === "ArrowLeft") {
            const newOffset = Math.max(anchorOffset - 1, 0);
            return {
                selectionStart: newOffset,
                selectionEnd: newOffset,
                changed: true
            };
        }
        else if (key === "ArrowRight") {
            const newOffset = Math.min(anchorOffset + 1, oldValue.length);
            return {
                selectionStart: newOffset,
                selectionEnd: newOffset,
                changed: true
            };
        }
        else if (key.length > 1) {
            key = "";
        }
        const startOffset = inputRange.startOffset;
        const endOffset = inputRange.endOffset;
        const prologEnd = Math.max(0, startOffset === endOffset && inputType === "deleteContentBackward" ? startOffset - 1 : startOffset);
        const prolog = oldValue.substring(0, prologEnd);
        const epilogStart = Math.min(oldValue.length, startOffset === endOffset && inputType === "deleteContentForward" ? startOffset + 1 : endOffset);
        const epilog = oldValue.substring(epilogStart, oldValue.length);
        const newValue = `${prolog}${key}${epilog}`;
        const newOffset = prologEnd + key.length;
        if (newValue === oldValue && newOffset === inputRange.startOffset && newOffset === inputRange.endOffset) {
            return {
                selectionStart: anchorOffset,
                selectionEnd: focusOffset,
                changed: false
            };
        }
        if (isElementType(element, "input", { type: "number" }) && !isValidNumberInput(newValue)) {
            return {
                selectionStart: anchorOffset,
                selectionEnd: focusOffset,
                changed: false
            };
        }
        triggerInputChange(element, newValue);
        if (element.selectionStart !== newOffset || element.selectionEnd !== newOffset) {
            try {
                element.setSelectionRange(newOffset, newOffset);
            }
            catch (_c) {
                // DOMException for invalid state is expected when calling this
                // on an element without support for setSelectionRange
            }
        }
        return {
            selectionStart: newOffset,
            selectionEnd: newOffset,
            changed: true
        };
    }
}
